/**
 * Indicates the current view type which determines how the media will be presented.
 */
export var ViewType;
(function (ViewType) {
    ViewType["Unknown"] = "unknown";
    ViewType["Audio"] = "audio";
    ViewType["Video"] = "video";
})(ViewType || (ViewType = {}));
